import WeaveMuiThemeProvider from './WeaveMuiThemeProvider';

export default WeaveMuiThemeProvider;
